class ApiError {
  
  constructor(m, st, s, e = null) {
    this.error = { 
      responseJSON: { error: m }, 
      statusText: st, 
      status: s,
      source: e 
    };
  }

}

export default ApiError;
